module.exports = __webpack_public_path__ + "img/hr-sand-dune-decal-13.a31a0fb2.png";